import PsLayout from "pages/structured/layout/PsLayout"
import "../builder.css"
import { useEffect, useState, useContext } from "react"
import AuthContext from "contexte/AuthContext"
import PageLoader from "components/pageLoader/PageLoader";
import { useNavigate } from "react-router-dom"
import { fetchSpDraft, saveSpDraft, uploadSpDraftPicture } from "services/spDraftServices"

const PsTexts = () => {

  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [product, setProduct] = useState({});
  const [lang, setLang] = useState('fr');
  const [descriptionDrafts, setDescriptionDrafts] = useState({ fr: { title: "", message: "" }, en: { title: "", message: "" } });
  const [moreInfoDrafts, setMoreInfoDrafts] = useState({ fr: { title: "", message: "" }, en: { title: "", message: "" } });
  const [documentDrafts, setDocumentDrafts] = useState({ fr: { title: "", url: "" }, en: { title: "", url: "" } });
  const [thumbnail, setThumbnail] = useState(null);

  const fieldKey = (base) => lang === 'en' ? `${base}_en` : base;
  const newDescription = descriptionDrafts[lang];
  const newMoreInfos = moreInfoDrafts[lang];
  const newDocument = documentDrafts[lang];

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setThumbnail(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(product);
    try {
      await saveSpDraft(user, window.location.pathname.split('/')[2], product);
      if (thumbnail) {
        await uploadSpDraftPicture({ user, id: product._id, type: 'thumbnails', picture: thumbnail })
      }
      navigate(`/structured-products/${window.location.pathname.split('/')[2]}/dates`)

    } catch (err) {
      console.log(err);
      setError(err)
    }
  }

  const fetchActualData = async () => {
    try {
      const response = await fetchSpDraft(user, window.location.pathname.split('/')[2]);
      setProduct(response)
      setLoading(false)
    } catch (e) {
      console.log(e);
      setLoading(false)
      setError(e)
    }
  }

  useEffect(() => {
    fetchActualData();
  }, [])

  const handleInputChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value
    })
  }

  const handleAddDescription = () => {
    const key = fieldKey('descriptions');
    if (newDescription.title && newDescription.message) {
      setProduct({
        ...product,
        [key]: [...(product[key] || []), newDescription]
      });
      setDescriptionDrafts({ ...descriptionDrafts, [lang]: { title: "", message: "" } });
    } else {
      alert("Veuillez remplir le titre et le message de la description.");
    }
  };

  const handleDescriptionChange = (index, field, value) => {
    const key = fieldKey('descriptions');
    const updatedDescriptions = [...product[key]];
    updatedDescriptions[index] = { ...updatedDescriptions[index], [field]: value };
    setProduct({ ...product, [key]: updatedDescriptions });
  };

  const handleRemoveDescription = (index) => {
    const key = fieldKey('descriptions');
    const updatedDescriptions = product[key].filter((_, i) => i !== index);
    setProduct({ ...product, [key]: updatedDescriptions });
  };

  const handleAddMoreInfo = () => {
    const key = fieldKey('more_info');
    if (newMoreInfos.title && newMoreInfos.message) {
      setProduct({
        ...product,
        [key]: [...(product[key] || []), newMoreInfos]
      });
      setMoreInfoDrafts({ ...moreInfoDrafts, [lang]: { title: "", message: "" } });
    } else {
      alert("Veuillez remplir le titre et le message de la description.");
    }
  };

  const handleMoreInfoChange = (index, field, value) => {
    const key = fieldKey('more_info');
    const updatedMoreInfo = [...product[key]];
    updatedMoreInfo[index] = { ...updatedMoreInfo[index], [field]: value };
    setProduct({ ...product, [key]: updatedMoreInfo });
  };

  const handleRemoveMoreInfo = (index) => {
    const key = fieldKey('more_info');
    const updatedMoreInfo = product[key].filter((_, i) => i !== index);
    setProduct({ ...product, [key]: updatedMoreInfo });
  };

  const handleAddDocument = () => {
    const key = fieldKey('documents');
    if (newDocument.title && newDocument.url) {
      setProduct({
        ...product,
        [key]: [...(product[key] || []), newDocument]
      });
      setDocumentDrafts({ ...documentDrafts, [lang]: { title: "", url: "" } });
    } else {
      alert("Veuillez remplir le titre et l'url du document.");
    }
  };

  const handleDocumentChange = (index, field, value) => {
    const key = fieldKey('documents');
    const updatedDocuments = [...product[key]];
    updatedDocuments[index] = { ...updatedDocuments[index], [field]: value };
    setProduct({ ...product, [key]: updatedDocuments });
  };

  const handleRemoveDocument = (index) => {
    const key = fieldKey('documents');
    const updatedDocuments = product[key].filter((_, i) => i !== index);
    setProduct({ ...product, [key]: updatedDocuments });
  };

  const handleFormKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
      e.preventDefault();
    }
  };

  const handleChangeUser = (e) => {
    console.log(e.target.value)
    if (e.target.value === "Clark Hassan") {
      setProduct({
        ...product,
        user: {
          uuid: "0c07284f-32f3-4605-a6af-e666e76eebb4",
          name: "Clark Hassan",
          description: "CEO Goliaths"
        }
      })
    }
  }

  useEffect(() => {
    console.log(product)
  }, [product])


  return (
    <PsLayout>
      {
        loading ? (
          <div className='pageLoaderBox'>
            <PageLoader />
          </div>
        ) : (
          error ? (
            <div>Erreur</div>
          ) : (
            <form onSubmit={handleSubmit} onKeyDown={handleFormKeyDown} className="psform">
              <div className="psform-lang-tabs">
                <div className={lang === 'fr' ? "psform-lang-tab-selected" : "psform-lang-tab"} onClick={() => setLang('fr')}>FR</div>
                <div className={lang === 'en' ? "psform-lang-tab-selected" : "psform-lang-tab"} onClick={() => setLang('en')}>EN</div>
              </div>

              <div key={lang} className="psform-lang-section">
                <div className="description-box-wrapper">
                  <span>Description</span>
                  {product[fieldKey('descriptions')] && product[fieldKey('descriptions')].map((description, index) => (
                    <div key={index} className="psform-description-box">
                      <div className="psform-input-box">
                        <input
                          className="psform-input-text-full"
                          type="text"
                          value={description.title}
                          onChange={(e) => handleDescriptionChange(index, 'title', e.target.value)}
                        />
                      </div>
                      <div className="psform-input-box">
                        <textarea
                          className="psform-input-text-full"
                          rows="3"
                          value={description.message}
                          onChange={(e) => handleDescriptionChange(index, 'message', e.target.value)}
                        />
                      </div>
                      <div onClick={() => handleRemoveDescription(index)} className="pointer button-add-new">Supprimer</div>
                    </div>
                  ))}

                  <div className="psform-input-box">
                    <span className="psform-input-label-text-small">Nouvelle description :</span>
                    <input
                      className="psform-input-text-full"
                      type="text"
                      value={newDescription.title}
                      onChange={(e) => setDescriptionDrafts({ ...descriptionDrafts, [lang]: { ...newDescription, title: e.target.value } })}
                    />
                  </div>
                  <div className="psform-input-box">
                    <textarea
                      className="psform-input-text-full"
                      rows="3"
                      value={newDescription.message}
                      onChange={(e) => setDescriptionDrafts({ ...descriptionDrafts, [lang]: { ...newDescription, message: e.target.value } })}
                    />
                  </div>
                  <div onClick={handleAddDescription} className="pointer button-add-new">Ajouter une description</div>
                </div>

                <div className="psform-input-box">
                  <span className="psform-input-label">Sous description :</span>
                  <input className="psform-input-text-full" type="text" name={fieldKey('sub_description')} defaultValue={product[fieldKey('sub_description')]} onChange={handleInputChange} />
                </div>

                <div className="description-box-wrapper">
                  <span>Plus d'infos</span>
                  {product[fieldKey('more_info')] && product[fieldKey('more_info')].map((moreinfo, index) => (
                    <div key={index} className="psform-description-box">
                      <div className="psform-input-box">
                        <input
                          className="psform-input-text-full"
                          type="text"
                          value={moreinfo.title}
                          onChange={(e) => handleMoreInfoChange(index, 'title', e.target.value)}
                        />
                      </div>
                      <div className="psform-input-box">
                        <textarea
                          className="psform-input-text-full"
                          rows="3"
                          value={moreinfo.message}
                          onChange={(e) => handleMoreInfoChange(index, 'message', e.target.value)}
                        />
                      </div>
                      <div onClick={() => handleRemoveMoreInfo(index)} className="pointer button-add-new">Supprimer</div>
                    </div>
                  ))}

                  <div className="psform-input-box">
                    <span className="psform-input-label-text-small">Nouvelle info :</span>
                    <input
                      className="psform-input-text-full"
                      type="text"
                      value={newMoreInfos.title}
                      onChange={(e) => setMoreInfoDrafts({ ...moreInfoDrafts, [lang]: { ...newMoreInfos, title: e.target.value } })}
                    />
                  </div>
                  <div className="psform-input-box">
                    <textarea
                      className="psform-input-text-full"
                      rows="3"
                      value={newMoreInfos.message}
                      onChange={(e) => setMoreInfoDrafts({ ...moreInfoDrafts, [lang]: { ...newMoreInfos, message: e.target.value } })}
                    />
                  </div>
                  <div onClick={handleAddMoreInfo} className="pointer button-add-new">Ajouter une info</div>
                </div>

                <div className="description-box-wrapper">
                  <span>Documents</span>
                  {product[fieldKey('documents')] && product[fieldKey('documents')].map((document, index) => (
                    <div key={index} className="psform-description-box">
                      <div className="psform-input-box">
                        <span className="psform-input-label-text-small">Titre</span>
                        <input
                          className="psform-input-text-full"
                          type="text"
                          value={document.title}
                          onChange={(e) => handleDocumentChange(index, 'title', e.target.value)}
                        />
                      </div>
                      <div className="psform-input-box">
                        <span className="psform-input-label-text-small">URL</span>
                        <input
                          className="psform-input-text-full"
                          type="text"
                          value={document.url}
                          onChange={(e) => handleDocumentChange(index, 'url', e.target.value)}
                        />
                      </div>
                      <div onClick={() => handleRemoveDocument(index)} className="pointer button-add-new">Supprimer</div>
                    </div>
                  ))}

                  <div className="psform-input-box">
                    <span className="psform-input-label-text-small">Titre du nouveau document :</span>
                    <input
                      className="psform-input-text-full"
                      type="text"
                      value={newDocument.title}
                      onChange={(e) => setDocumentDrafts({ ...documentDrafts, [lang]: { ...newDocument, title: e.target.value } })}
                    />
                  </div>
                  <div className="psform-input-box">
                    <span className="psform-input-label-text-small">URL du nouveau document :</span>
                    <input
                      className="psform-input-text-full"
                      type="text"
                      value={newDocument.url}
                      onChange={(e) => setDocumentDrafts({ ...documentDrafts, [lang]: { ...newDocument, url: e.target.value } })}
                    />
                  </div>
                  <div onClick={handleAddDocument} className="pointer button-add-new">Ajouter un document</div>
                </div>
              </div>

              <div className="psform-input-box-flex">
                <div className="psform-input-box">
                  <span className="psform-input-label">Id de la vidéo :</span>
                  <input className="psform-input-text-full" type="text" name="video_url" defaultValue={product.video_url} onChange={handleInputChange} />
                </div>
                <div className="psform-input-box">
                  <div className="psform-input-box">
                    <span className="psform-input-label">Image de couverture :</span>
                    <input
                      className="psform-input-text"
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  {
                    (imagePreview || product.video_thumbnail) && (
                      <div className="psform-preview-box">
                        <img className="psform-preview-img" src={imagePreview || product.video_thumbnail} alt="Aperçu du produit" />
                      </div>
                    )
                  }
                </div>
              </div>

              <div className="psform-input-box">
                <span className="psform-input-label">Utilisateur affiché :</span>
                <select name="user" id="user" className="psform-input-text" defaultValue={product.user?.name} onChange={handleChangeUser}>
                  <option>Choose user</option>
                  <option value="Clark Hassan">Clark Hassan</option>
                </select>
              </div>

              <div className="psform-submit-box">
                <button type="submit" className="psform-submit">Sauvegarder et continuer</button>
              </div>
            </form >
          )
        )
      }
    </PsLayout >
  )
}

export default PsTexts